import React, { useEffect } from "react";
import { AutoPayComponent } from "../../features/Dashboard/components/AutoPayComponent";
import { trackEvent } from "../../utils/analytics";
import { getPaymentMethods } from "../../features/PaymentMethods/PaymentMethods.slice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";

const AutoPayView: React.FC = () => {
  const { loading: loadingAS } = useAppSelector((state) => state.accountSummary);
  const { loading: loadingPM } = useAppSelector((state) => state.payment.methods);
  const dispatch = useAppDispatch();

  useEffect(() => {
    trackEvent({ action: "View > AutoPay" });
    dispatch(getPaymentMethods()).catch((e) => {
      throw new Error(e as string);
    });
  }, [dispatch]);

  if (loadingAS || loadingPM) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex-grow-1 justify-content-center">
      <AutoPayComponent mode="full" />
    </div>
  );
};

export default AutoPayView;
